import theme from 'theme';

export const menuButtonSx = {
  color: theme.palette.text.primary,
  margin: '8px',
  textTransform: 'none',
  textAlign: 'left',
  justifyContent: 'flex-start',
  transition: 'background-color 0.15s ease',
  '&:hover': {
    backgroundColor: theme.palette.background.default
  },
  '&.bordered': {
    border: `1px solid ${theme.palette.divider}`
  }
};

export const spaceSelectorButtonSx = {
  ...menuButtonSx,
  ml: { lg: 0 },
  px: { lg: 1 },
};

export const sideMenuDrawerSx = {
  '&.full-width': {
    '& > div': {
      width: '100vw'
    }
  },
  '& > div': {
    zIndex: 1,
    overflow: { xs: 'auto', lg: 'hidden' },
    boxSizing: 'border-box',
    position: 'fixed',
    top: 0,
    paddingTop: `calc(${theme.height.topMenu} - 10px)`,
    width: theme.width.sideMenu,
    border: 'none',
    borderRight: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.primary.white,
    backgroundImage: 'none',
    '& ul': {
      paddingTop: 0,
      '& a:first-child': {
        marginTop: 0
      }
    }
  }
};

export const listMenuItemSx = {
  textDecoration: 'none',
  color: theme.palette.text.primary,
  fontSize: `${theme.typography.fontSize}px`,
  gap: '10px',
  margin: '4px 12px',
  justifyContent: 'flex-start',
  borderRadius: '8px',
  transition: 'background-color 0.15s ease',
  minHeight: '44px',
  padding: '8px 14px',
  '& .MuiListItemText-root': {
    margin: 0
  },
  '& .MuiListItemText-primary': {
    fontSize: `${theme.typography.fontSize}px`,
    fontWeight: 500
  },
  '& .MuiSvgIcon-root': {
    fontSize: '22px',
    flexShrink: 0,
    color: theme.palette.text.secondary
  },
  '&.Mui-selected': {
    background: 'none',
    backgroundColor: theme.palette.menu.selected,
    '& .MuiSvgIcon-root': { color: theme.palette.primary.main },
    '& .MuiListItemText-primary': { fontWeight: 600 },
    '&:hover': {
      backgroundColor: theme.palette.menu.selected
    }
  }
};

export const appBarSx = {
  backgroundColor: theme.palette.primary.white,
  backgroundImage: 'none',
  boxShadow: 'none',
  borderBottom: `1px solid ${theme.palette.divider}`,
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  width: '100%',
  height: theme.height.topMenu
};

export const sideMenuGroupHeaderSx = {
  fontSize: `${theme.typography.fontSizeSmall}px`,
  fontWeight: 500,
  letterSpacing: '0.01em',
  color: theme.palette.text.secondary,
  padding: '20px 26px 6px',
  display: 'block'
};

export const sidebarToggleButtonSx = {
  textTransform: 'none',
  color: theme.palette.text.primary
};

export const sideMenuListSx = {
  flex: { lg: 1 },
  minHeight: 0,
  overflowY: { lg: 'auto' },
  pb: { xs: 8, lg: 0 },
};

export const sideMenuFooterSx = {
  flexShrink: 0,
  borderTop: `1px solid ${theme.palette.divider}`,
  p: 1.5,
};

export const sideMenuCollapseButtonSx = {
  ...sidebarToggleButtonSx,
  width: '100%',
  justifyContent: 'flex-start',
  minHeight: 44,
  px: 1.75,
  gap: 0.5,
};
